import _objectSpread from "C:\\Users\\surac\\Documents\\GitHub\\tffwebsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
export var POP = 'Navigation/POP';
export var POP_TO_TOP = 'Navigation/POP_TO_TOP';
export var PUSH = 'Navigation/PUSH';
export var RESET = 'Navigation/RESET';
export var REPLACE = 'Navigation/REPLACE';
export var COMPLETE_TRANSITION = 'Navigation/COMPLETE_TRANSITION';
export var pop = function pop(payload) {
  return _objectSpread({
    type: POP
  }, payload);
};
export var popToTop = function popToTop(payload) {
  return _objectSpread({
    type: POP_TO_TOP
  }, payload);
};
export var push = function push(payload) {
  return _objectSpread({
    type: PUSH
  }, payload);
};
export var reset = function reset(payload) {
  return _objectSpread({
    type: RESET,
    key: null
  }, payload);
};
export var replace = function replace(payload) {
  return _objectSpread({
    type: REPLACE
  }, payload);
};
export var completeTransition = function completeTransition(payload) {
  return _objectSpread({
    type: COMPLETE_TRANSITION,
    preserveFocus: true
  }, payload);
};